import { Injectable, Injector } from "@angular/core";
import { HttpHeaders, HttpClient, HttpParams, HttpRequest } from "@angular/common/http";
import { AppTranslationService } from "../../services/app-translation.service";
import { ConfigurationService } from "../../services/configuration.service";
import { LocalStoreManager } from "../../services/local-store-manager.service";
import { DBkeys } from "../../services/db-Keys";
import { EndpointFactory } from "../../services/endpoint-factory.service";
import { HCP } from "../../models/lookups/hcp.model";
import { Observable } from "rxjs";


@Injectable({
  providedIn: "root"
})
export class HCPService extends EndpointFactory {

 
  //headers = new HttpHeaders();
  //culture: string = "ar";

  constructor(protected http: HttpClient,
    private translateService: AppTranslationService,
    protected configurations: ConfigurationService, injector: Injector,
    private localStorage: LocalStoreManager) {
    super(http, configurations, injector);

  
    //this.headers = new HttpHeaders({
    //  'Authorization': "Bearer " + this.localStorage.getData(DBkeys.ACCESS_TOKEN),
    //  'Content-Type': "application/json",
    //  'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
    //  'App-Version': ConfigurationService.appVersion,
    //  'Access-Control-Allow-Origin': "*",
    //  'Access-Control-Allow-Methods': "GET,POST,PATCH,PUT,DELETE,OPTIONS",
    //  'Access-Control-Allow-Headers': "Origin, Content-Type, X-Auth-Token"
    //});
    //this.culture = this.configurations.language;
  }


  SearchHCPs(searchText: string, specialityId: number, hcpClassId: number, pageSize: number, pageNumber: number, excludedHcpId: number=0, denormalizeClasses: boolean = false, specialityIds: number[] = null) {
    let myParams = new HttpParams()
      .set("specialityId", specialityId == undefined ? "0" : specialityId.toString())
      .set("hcpClassId", hcpClassId == undefined ? "0" : hcpClassId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set("pageNumber", pageNumber.toString())
      .set("excludedHcpId", excludedHcpId == undefined ? "0" : excludedHcpId.toString())
      .set("pageSize", pageSize.toString())
      .set("denormalizeClasses", denormalizeClasses ? "true" : "false");
    if (specialityIds) {
      specialityIds.forEach(id => myParams = myParams.append("specialityIds", String(id)));
    }
    return this.http.get(this.configurations.apiAddress + "/api/hcp/search", {params: myParams });
  }

  GetPendingApproval(searchText: string, specialityId: number, hcpClassId: number, pageSize: number, pageNumber: number, startDate, endDate, searchedByUserid) {
    let myParams = new HttpParams()
      .set("specialityId", specialityId == undefined ? "0" : specialityId.toString())
      .set("hcpClassId", hcpClassId == undefined ? "0" : hcpClassId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set("pageNumber", pageNumber.toString())
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("pageSize", pageSize.toString());
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getPendingApproval", { params: myParams });
  }

  GetPendingEditApproval(searchText: string, specialityId: number, hcpClassId: number, pageSize: number, pageNumber: number, startDate, endDate, searchedByUserid) {
    let myParams = new HttpParams()
      .set("specialityId", specialityId == undefined ? "0" : specialityId.toString())
      .set("hcpClassId", hcpClassId == undefined ? "0" : hcpClassId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set("pageNumber", pageNumber.toString())
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("pageSize", pageSize.toString());
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getPendingEditApproval", { params: myParams });
  }

  getHcpEditHistory(searchText: string, pageNumber: number, startDate, endDate, requestedByUserid, status) {
    let myParams = new HttpParams()
      .set("searchText", searchText == undefined ? "" : searchText)
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("requestedByUserid", requestedByUserid == undefined ? "" : requestedByUserid.toString())
      .set("status", status == undefined ? "" : status.toString())
      .set("pageNumber", pageNumber.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hcp/editHistory", { params: myParams });
  }

  getHcpEditRequestProposedData(editRequestId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getEditRequestProposedData/" + editRequestId);
  }

  getHcpEditRequestComparison(editRequestId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getEditRequestComparison/" + editRequestId);
  }

  approveHcpEditRequest(editRequestId: number) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/approveEditRequest/" + editRequestId, null);
  }

  rejectHcpEditRequest(editRequestId: number) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/rejectEditRequest/" + editRequestId, null);
  }


  SaveHCP(hcp: HCP) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/save", hcp);
  }

  // keepSurvivingRepLinks: when both have a rep link in the same business unit, keep the surviving HCP's (true) or the absorbed one's
  mergeHCPs(hcpId: number, HCPs: HCP[], keepSurvivingRepLinks: boolean = false) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/merge/" + hcpId + "?keepSurvivingRepLinks=" + keepSurvivingRepLinks, HCPs);
  }

  rejectAddNewHcp(hcpId: number) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/rejectAddNewHcp/" + hcpId, null);
  }

  getUserAddingReuqest(startDate, endDate, status, pageNumber, pageSize, searchedByUserid, search) {
    let myParams = new HttpParams()
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("status", status == undefined ? "" : status.toString())
      .set("pageNumber", pageNumber.toString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("search", search == undefined ? "" : search)
      .set("pageSize", pageSize.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hcp/getUserAddingReuqest", { params: myParams });
  }

  GetAllHCPClasses(searchText: string) {
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getAllHCPCLasses/" + searchText);
  }

  GetAllSpecialities(searchText: string) {
    return this.http.get(this.configurations.apiAddress + "/api/speciality/getAll/" + searchText);
  }
  GetHCPById(id: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getById/" + id);
  }
  DeleteHCP(id: number) {
    return this.http.delete(this.configurations.apiAddress + "/api/hcp/delete/" + id);
  }


  generateOTP(hcpId) {
    return this.http.get(this.configurations.apiAddress + "/api/HCP/generateOTPCode/" + hcpId, { responseType: 'text' });
  }

  downloadCsvTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/HCP/downloadCSVTemplate", { responseType: "blob" });
  }

  uploadCsvTemplate(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/HCP/uploadCSVTemplate", formData);
   
  }

  updateFromCSV(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/HCP/updateFromCSV", formData);

  }

  downloadErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/HCP/downloadErrorFile", { responseType: "blob" });
  }

  getHcosHcps() {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcosHcps");
  }

  getHCPBrandHCPClasses(hcpId, includeHistory: boolean = false) {
    return this.http.get(`${this.configurations.apiAddress}/api/HCP/getHCPBrandHCPClasses/${hcpId}?includeHistory=${includeHistory}`);
  }
  saveCPBrandHCPClass(hcpBrandHCPClass) {
    return this.http.post(`${this.configurations.apiAddress}/api/HCP/saveHCPBrandHCPClass`, hcpBrandHCPClass);
  }

  deleteCPBrandHCPClass(hcpBrandHCPClassId) {
    return this.http.delete(`${this.configurations.apiAddress}/api/HCP/deleteHCPBrandHCPClass/${hcpBrandHCPClassId}`);
  }


  searchUserHcps(searchText?: string, userId?: number, getLastVisitNote: boolean = false, buId = 0, getNoOfVisistsInMonth: boolean = false) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("getLastVisitNote", getLastVisitNote.toString())
      .set("userId", userId === undefined ? "" : userId.toString())
      .set("getNoOfVisistsInMonth", getNoOfVisistsInMonth.toString())
      .set("buId", buId.toString());


    return this.http.get(`${this.configurations.apiAddress}/api/HCP/userHcps`, { params: myParams });
  }
  allUserHcps(searchText?: string, userId?: number, pageSize?: number, pageNumber?: number, buId = 0) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("pageSize", pageSize === undefined ? "900000" : pageSize.toString())
      .set("pageNumber", pageNumber === undefined ? "1" : pageNumber.toString())
      .set("buId", buId.toString())
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/HCP/allUserHcps`, { params: myParams });
  }
  alluserHcpsTotalCount(searchText?: string, userId?: number, buId = 0) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("buId", buId.toString())
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/HCP/alluserHcpsTotalCount`, { params: myParams });
  }

  downloadMergeHcpsIntoHcpCSVTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/HCP/downloadMergeHcpsIntoHcpCSVTemplate", { responseType: "blob" });
  }

  downloadMergeHcpsIntoHcpErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/HCP/downloadMergeHcpsIntoHcpErrorFile", { responseType: "blob" });
  }

  provisionMergeHcpsIntoHcp(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/HCP/provisionMergeHcpsIntoHcp", formData);
  }

  saveHcpAttachements(hcp: HCP) {
    return this.http.post(this.configurations.apiAddress + "/api/HCP/saveHcpAttachements", hcp);
  }
  getHcpAttachements(hcpId) {
    return this.http.get(`${this.configurations.apiAddress}/api/HCP/getHcpAttachements/${hcpId}`);
  }

  saveHcpApprovalCycle(hcp: any) {
    return this.http.post(this.configurations.apiAddress + "/api/hcp/saveHcpApprovalCycle", hcp);
  }

  getHcpApprovalCycle() {
    return this.http.get(this.configurations.apiAddress + "/api/hcp/getHcpApprovalCycle");
  }

}
